export const getProxyCallerBinary = async (): Promise<Uint8Array> => {
  // Source: https://github.com/odradev/odra/blob/release/2.9.1/resources/proxy_caller_with_return.wasm
  // sha256: d7de3cc9d8097dd8ac210d24cff21f402cf0c64f920d50c505338674d511dfdb (41012 bytes)
  // The plain proxy expects a unit return and fails on non-empty contract results.
  const response = await fetch(new URL('./proxy-caller.wasm', import.meta.url));
  if (!response.ok) {
    throw new Error('Failed to load the proxy caller.');
  }
  return new Uint8Array(await response.arrayBuffer());
};
